import useEdgeDataFetcher from './useEdgeDataFetcher'
import { useEffect, useState } from 'react'

export default (landingContext, updateGlobalState, plateStateLookupVin) => {
  const [plateState, setPlateState] = useState()
  const [submitPlateStateCount, setSubmitPlateStateCount] = useState(0)
  const [plateStateError, setPlateStateError] = useState(false)

  const [plateLookupVinObject, , plateLookupIsFetching] = useEdgeDataFetcher(!plateStateLookupVin && plateState && `/plate2vin/lookup?stateCode=${plateState.state}&plateNumber=${plateState.plate}`, undefined, undefined, 'plate2vin')

  landingContext.setLoadingInfo('Lookup plate', plateLookupIsFetching)
  const plateLookupVinObjectResolvedVin = plateLookupVinObject && plateLookupVinObject.vins && plateLookupVinObject.vins[0] && plateLookupVinObject.vins[0].vin
  const plateLookupError = !plateLookupVinObjectResolvedVin && !plateStateLookupVin && !!plateState && !plateLookupIsFetching //NOT THE IDEAL WAY TO CHECK FETCH ERRORS

  useEffect(() => {
    if (plateLookupVinObjectResolvedVin) {
      updateGlobalState({ isIneligibleYear: false, plateStateLookupVin: plateLookupVinObjectResolvedVin, fireAnalytics: 'continue_timbuybkhome_selltrade_lp' })
    }
    setPlateStateError(!!plateLookupError)
  }, [plateLookupVinObjectResolvedVin, plateLookupError, submitPlateStateCount, updateGlobalState]) //submitVinCount

  return { plateStateError, setPlateStateError, setPlateState, submitPlateStateCount, setSubmitPlateStateCount }
}
